import React, { createContext, useState } from "react";

export const AuthContext = createContext();

function AuthContextProvider({ children }) {
  const [isAuth, setIsAuth] = useState(false);

  const [UserDetails, setUserDetails] = useState({});

  const Login = (val) => {
    setIsAuth(true);
    setUserDetails(val);
  };

  const Logout = () => {
    setIsAuth(false);
    setUserDetails("");
  };

  return (
    <AuthContext.Provider
      value={{ isAuth, Login, Logout, UserDetails, setUserDetails }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContextProvider;
